/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class RecordRestoreResult {
  /**
  * Locations where the query results are saved to. 
  */
  'outputLocations': Array<string>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "outputLocations",
      "baseName": "outputLocations",
      "type": "Array<string>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return RecordRestoreResult.attributeTypeMap;
  }

  public constructor() {
  }
}

